import { Typography } from "@mui/material";

export default function EnableVeritySwitch({
	enabled,
	setEnabled,
}: {
	enabled: boolean;
	setEnabled: (_: boolean) => void;
}) {
	return (
		<label
			style={{
				cursor: "pointer",
			}}
		>
			<div
				style={{
					display: "grid",
					gridTemplateColumns: "auto 1fr",
					gridTemplateRows: "auto auto",
					padding: "0.6rem 0",
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						gap: "20px",
					}}
				>
					<Typography
						variant="h3"
						style={{
							flex: "1 1 0%",
							margin: "0.3rem 0",
							overflowWrap: "anywhere",
							overflow: "hidden",
							userSelect: "none",
							fontSize: "1rem",
							fontWeight: "700",
						}}
					>
						YuJa Verity Test Proctoring
					</Typography>
				</div>
			</div>
			<div
				style={{
					borderBottom: "1px solid var(--d2l-color-mica)",
				}}
			/>
			<ul
				style={{
					color: "var(--d2l-color-tungsten)",
					listStyle: "none",
					fontWeight: "400",
					lineHeight: "1rem",
					margin: "auto",
					paddingTop: "0.9rem",
					paddingBottom: enabled ? "0.9rem" : "0",
					paddingLeft: "0",
				}}
			>
				<li style={{ display: "flex" }}>
					<input
						type="checkbox"
						onChange={() => {
							setEnabled(!enabled);
						}}
						checked={enabled}
						style={{ marginRight: "5px" }}
					></input>
					Create a proctored environment to safeguard the integrity of your assessment through custom settings.
				</li>
			</ul>
		</label>
	);
}
